import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-df96887e"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "empty-wrap"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  class: "empty-img",
  src: "/static/img-empty.png"
}, null, -1));

const _hoisted_3 = /*#__PURE__*/_createTextVNode("暂无数据");

export function render(_ctx, _cache) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("p", null, [_renderSlot(_ctx.$slots, "default", {}, () => [_hoisted_3], true)])]);
}